import {gistActionTypes} from '../_constants';
import {gistService} from '../_services';
import {alertActions} from './';

export const gistActions = {
    getGist
};

/**
 * Redux action that fetches the gist of a source
 *
 * @param uuid the uuid of the source
 * @return {function(...[*]=)}
 */
function getGist(uuid) {
    return dispatch => {

        // utility constants - contains all module-related dispatches from this function
        const dispatchRequestStarted = () => dispatch({ type: gistActionTypes.GET_SOURCE_GIST_REQUEST });
        const dispatchRequestSuccess = (gist) => dispatch({ type: gistActionTypes.GET_SOURCE_GIST_SUCCESS, gist });
        const dispatchRequestError  = () => dispatch({ type: gistActionTypes.GET_SOURCE_GIST_FAILURE });

        // dispatch that sources are being fetched
        dispatchRequestStarted();

        // pass the parameters to the service
        gistService.getGist(uuid)
            .then(
                gist => {
                    if( gist ){
                        // dispatch a success if the service returns the requested gist
                        dispatchRequestSuccess(gist);
                        dispatch(alertActions.success(" Gist successfully fetched. "));
                    }
                },
                error => {
                    // dispatch a failure for the fetching sources and alert engine with appropriate message
                    dispatchRequestError();
                    dispatch(alertActions.error(error));
                }
            );
    };
}